import { createAction, props } from '@ngrx/store';
import { IField, IRegistrationData } from '@shared/model/basic-data';

export enum RegistrationDataActionTypes {
  GET_REGISTRATION_DATA = '[Basic Data] Get Registration Data',
  GET_REGISTRATION_DATA_SUCCESS = '[Basic Data] Get Registration Data Success',
  GET_REGISTRATION_DATA_FAILURE = '[Basic Data] Get Registration Data Failure',

  UPDATE_REGISTRATION_DATA = '[Basic Data] Update Registration Data',
  UPDATE_REGISTRATION_DATA_SUCCESS = '[Basic Data] Update Registration Data Success',
  UPDATE_REGISTRATION_DATA_FAILURE = '[Basic Data] Update Registration Data Failure',
}

export const getRegistrationData = createAction(
  RegistrationDataActionTypes.GET_REGISTRATION_DATA,
  props<{ id: number }>(),
);

export const getRegistrationDataSuccess = createAction(
  RegistrationDataActionTypes.GET_REGISTRATION_DATA_SUCCESS,
  props<{ registrationData: IRegistrationData }>(),
);

export const getRegistrationDataFailure = createAction(RegistrationDataActionTypes.GET_REGISTRATION_DATA_FAILURE);

export const updateRegistrationData = createAction(
  RegistrationDataActionTypes.UPDATE_REGISTRATION_DATA,
  props<{ id: number; data: IField }>(),
);

export const updateRegistrationDataSuccess = createAction(
  RegistrationDataActionTypes.UPDATE_REGISTRATION_DATA_SUCCESS,
  props<{ data: IField }>(),
);

export const updateRegistrationDataFailure = createAction(RegistrationDataActionTypes.UPDATE_REGISTRATION_DATA_FAILURE);
